import { CustomField, CustomFieldTypes } from "@/types";
import { FilterMatchMode } from "@primevue/core/api";
import { DataTableFilterMeta } from "primevue";

const CUSTOM_FIELD_ENTITIES = new Set(["Order", "OrderItem"]);

export function customFieldColumnKey(field: Pick<CustomField, "id" | "entity">): string {
  const id = field.id;
  if (id == null) return field.entity === "OrderItem" ? "orderItem.customField.unknown" : "order.customField.unknown";
  return field.entity === "OrderItem" ? `orderItem.customField.${id}` : `order.customField.${id}`;
}

export function matchModeForCustomFieldType(fieldType?: CustomFieldTypes | string) {
  switch (fieldType) {
    case "number":
    case "checkbox":
      return FilterMatchMode.EQUALS;
    case "date":
      return FilterMatchMode.DATE_IS;
    case "dropdown":
    case "multiselect":
      return FilterMatchMode.IN;
    default:
      return FilterMatchMode.CONTAINS;
  }
}

export function buildCustomFieldFilterMeta(customFields?: CustomField[] | null): DataTableFilterMeta {
  const meta: DataTableFilterMeta = {};
  if (!customFields?.length) return meta;

  for (const field of customFields) {
    if (field.id == null || field.isInternal) continue;
    if (!CUSTOM_FIELD_ENTITIES.has(field.entity)) continue;
    const key = customFieldColumnKey(field);
    meta[key] = { value: null, matchMode: matchModeForCustomFieldType(field.fieldType) };
  }
  return meta;
}

/** Ensure filter meta has entries for all custom fields without wiping existing values. */
export function ensureCustomFieldFilters(filters: DataTableFilterMeta, customFields?: CustomField[] | null): DataTableFilterMeta {
  const customMeta = buildCustomFieldFilterMeta(customFields);
  for (const [key, entry] of Object.entries(customMeta)) {
    if (!(key in filters)) {
      (filters as any)[key] = entry;
    }
  }
  return filters;
}

export function isCustomFieldFilterKey(key: string): boolean {
  return /^(order|orderItem)\.customField\.\d+$/.test(key);
}
